import imgHoangSaIslands from 'assets/images/EVG/HoangSa.png';
import imgTruongSaIslands from 'assets/images/EVG/TruongSa.png';
import ChargeHelper from 'features/Charge/chargeHelper';
import StationInfoBoxView from 'features/Charge/ChargeStation/components/StationInfoBoxView';
import AppRoute from 'general/constants/AppRoute';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import ReactDOMServer from 'react-dom/server';

SOCStationMapView.propTypes = {
  stationList: PropTypes.array,
};

function SOCStationMapView({ stationList = [] }) {
  // MARK: ---- PROPERTIES ----
  const mapRef = useRef(null); // Tham chiếu đến bản đồ
  const infoboxRef = useRef(null); // Tham chiếu đến Infobox
  const [MicrosoftLoaded, setMicrosoftLoaded] = useState(false);
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://www.bing.com/api/maps/mapcontrol?callback=GetMap&key=${process.env.REACT_APP_BING_MAP_API_KEY}&setMkt=vi-VN&setLang=vi`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    window.GetMap = () => {
      setMicrosoftLoaded(true);
    };
  }, []);
  useEffect(() => {
    if (MicrosoftLoaded && !mapRef.current) {
      initializeMap();
    }
  }, [MicrosoftLoaded]);
  useEffect(() => {
    if (MicrosoftLoaded) {
      hideInfobox();
      updatePushpins();
      updateMapCenter(
        new Microsoft.Maps.Location(
          stationList[0]?.latitude || 14.0583,
          stationList[0]?.longitude || 105.2772
        )
      );
    }
  }, [stationList, MicrosoftLoaded]);

  // MARK: ---- METHODS ----
  const showInfobox = (station, location) => {
    if (infoboxRef.current) {
      const infoboxHtml = ReactDOMServer.renderToString(
        <div className="position-relative">
          <StationInfoBoxView station={station} />
          <div
            id="infobox-div"
            className="position-absolute w-100 h-100 left-0 top-0 cursor-pointer"
          ></div>
        </div>
      );

      infoboxRef.current.setOptions({
        location: location,
        htmlContent: infoboxHtml,
        visible: true,
        offset: new Microsoft.Maps.Point(-150, 54),
      });
      // Gắn sự kiện click vào nút sau khi Infobox được hiển thị
      setTimeout(() => {
        const div = document.getElementById('infobox-div');
        if (div) {
          div.addEventListener('click', () => {
            Utils.openInNewTab(`${AppRoute.stationList}/${station.stationId}`);
          });
        }
      }, 0);
    }
  };
  const hideInfobox = () => {
    if (infoboxRef.current) {
      infoboxRef.current.setOptions({ visible: false });
    }
  };

  const updatePushpins = () => {
    if (!mapRef.current) return;

    // Xóa tất cả các pushpins cũ
    mapRef.current.entities.clear();

    // Thêm các pushpins mới
    stationList.forEach((station) => {
      if (Utils.isValid(station.latitude) && Utils.isValid(station.longitude)) {
        const location = new Microsoft.Maps.Location(station?.latitude, station?.longitude);
        const pushpin = new Microsoft.Maps.Pushpin(location, {
          icon: ChargeHelper.Utils.getChargeStationPinIcon(station.status),
          title: '',
        });

        // Thêm sự kiện click cho pushpin
        // Microsoft.Maps.Events.addHandler(pushpin, 'click', () => {
        //   showInfobox(station, location);
        // });

        // Thêm pushpin vào bản đồ
        mapRef.current.entities.push(pushpin);
      }
    });
  };
  const updateMapCenter = (location) => {
    if (mapRef.current) {
      mapRef.current.setView({
        center: location, // Cập nhật vị trí trung tâm
        zoom: 6, // Giữ nguyên mức zoom hiện tại
      });
    }
  };
  const initializeMap = () => {
    const mapElement = document.getElementById('soc-station-map-view-id');
    if (!mapElement || !MicrosoftLoaded) {
      console.error('Map element is not ready or Microsoft is not loaded.');
      return;
    }

    const map = new Microsoft.Maps.Map(mapElement, {
      center: new Microsoft.Maps.Location(14.0583, 105.2772),
      zoom: 6,
      customMapStyle: {
        elements: {
          mapElement: {
            labelColor: '#FFFFFF',
            labelOutlineColor: '#000000',
          },
          water: { fillColor: '#141631', labelVisible: false },
          point: { visible: false },
          populatedPlace: { labelVisible: true },
          pointOfInterest: { labelVisible: false },
          park: { labelVisible: false },
          landuse: { labelVisible: false },
          arterialRoad: { labelVisible: false },
          road: { fillColor: 'transparent', labelVisible: false },
          street: { labelVisible: false },
        },
        settings: { landColor: '#29273D' },
      },
      mapTypeId: Microsoft.Maps.MapTypeId.grayscale,
      showZoomButtons: false,
      showMapTypeSelector: false,
      showLocateMeButton: false,
    });
    mapRef.current = map;
    // Tạo Infobox và lưu vào ref
    const infobox = new Microsoft.Maps.Infobox(map.getCenter(), {
      visible: false,
    });
    infobox.setMap(map);
    infoboxRef.current = infobox;

    // Thêm sự kiện click vào bản đồ để ẩn Infobox
    Microsoft.Maps.Events.addHandler(map, 'click', () => {
      hideInfobox();
    });

    function TopographicOverlay(bounds, imageSrc) {
      this.bounds = bounds;
      this.imageSrc = imageSrc;
      this.imgElement = null;
    }

    TopographicOverlay.prototype = new Microsoft.Maps.CustomOverlay();

    TopographicOverlay.prototype.onAdd = function () {
      const img = document.createElement('img');
      img.src = this.imageSrc;
      img.style.position = 'absolute';
      img.style.pointerEvents = 'none';
      this.imgElement = img;
      this.setHtmlElement(img);
    };

    TopographicOverlay.prototype.onLoad = function () {
      const repositionOverlay = () => {
        const topLeft = map.tryLocationToPixel(
          this.bounds.getNorthwest(),
          Microsoft.Maps.PixelReference.control
        );
        const bottomRight = map.tryLocationToPixel(
          this.bounds.getSoutheast(),
          Microsoft.Maps.PixelReference.control
        );

        if (topLeft && bottomRight) {
          this.imgElement.style.left = `${topLeft.x}px`;
          this.imgElement.style.top = `${topLeft.y}px`;
          this.imgElement.style.width = `${bottomRight.x - topLeft.x}px`;
          this.imgElement.style.height = `${bottomRight.y - topLeft.y}px`;
        }
      };

      Microsoft.Maps.Events.addHandler(map, 'viewchange', repositionOverlay);
      repositionOverlay();
    };

    TopographicOverlay.prototype.onRemove = function () {
      Microsoft.Maps.Events.removeHandler(this.viewChangeEvent);
      if (this.imgElement && this.imgElement.parentNode) {
        this.imgElement.parentNode.removeChild(this.imgElement);
      }
      this.imgElement = null;
    };

    const boundHoangSa = Microsoft.Maps.LocationRect.fromCorners(
      new Microsoft.Maps.Location(17.0, 111.5),
      new Microsoft.Maps.Location(18.0, 112.5)
    );
    const overlayHoangSa = new TopographicOverlay(boundHoangSa, imgHoangSaIslands);
    map.layers.insert(overlayHoangSa);

    const boundTruongSa = Microsoft.Maps.LocationRect.fromCorners(
      new Microsoft.Maps.Location(11.0, 113.5),
      new Microsoft.Maps.Location(12.0, 114.5)
    );
    const overlayTruongSa = new TopographicOverlay(boundTruongSa, imgTruongSaIslands);
    map.layers.insert(overlayTruongSa);

    stationList.forEach((station) => {
      if (Utils.isValid(station.latitude) && Utils.isValid(station.longitude)) {
        const location = new Microsoft.Maps.Location(station.latitude, station.longitude);
        const pushpin = new Microsoft.Maps.Pushpin(location, {
          icon: ChargeHelper.Utils.getChargeStationPinIcon(station.status),
          title: '',
        });
        map.entities.push(pushpin);
      }
    });
  };

  return <div id="soc-station-map-view-id"></div>;
}

export default SOCStationMapView;
